import { Alert, Collapse } from '@mui/material'
import { isDropAmountInvalid } from '../editor/DropCreatorUtils'
import { DropAlert } from './DropAlert'
import { DropPaper } from './DropPaper'
import InputField from '../common/util/InputField'

export const DropAmountEditor = ({
    maxClaimable,
    setMaxClaimable,
    accountLimit,
    setAccountLimit,
    accountLimitCoolDown,
    setAccountLimitCoolDown,
    ramToBuyInWax,
    extraRamBytesAfterRamBought,
    setRamToBuyInWax,
    checkedTemplateIds = null,
    mustBeFinite,
    isPremint,
    isPfp = false,
}) => {
    return (
        <DropPaper
            expandable
            id={'DropAmountEditor'}
            title="Purchase Limits and Restrictions"
            error={isDropAmountInvalid({
                maxClaimable,
                accountLimit,
                accountLimitCoolDown,
                waxRam: ramToBuyInWax,
                ramBytes: extraRamBytesAfterRamBought,
                checkedTemplateIds,
                mustBeFinite,
                isPremint,
                isPfp,
            })}
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-10 mb-5">
                <div className="my-auto">
                    The maximum number of drops that will be available to claim.
                    (0 = unlimited)
                </div>
                <div>
                    <InputField
                        className="w-64"
                        type="number"
                        variant="bordered"
                        isRequired={true}
                        label="Max Claimable Drops"
                        onWheel={(e) => e.target.blur()}
                        isInvalid={mustBeFinite && maxClaimable === 0}
                        value={maxClaimable}
                        onChange={(e) => {
                            setMaxClaimable(parseInt(e.target.value))
                        }}
                        min={mustBeFinite ? 1 : 0}
                    />
                </div>
                <div className="my-auto">
                    The max amount of drops to purchase from a single account.
                    (0 = unlimited)
                </div>
                <div>
                    <InputField
                        className="w-64"
                        type="number"
                        variant="bordered"
                        isRequired={true}
                        label="Account limit"
                        onWheel={(e) => e.target.blur()}
                        value={accountLimit}
                        onChange={(e) =>
                            setAccountLimit(parseInt(e.target.value))
                        }
                        min={0}
                    />
                </div>
                <div className="my-auto">
                    Cooldown in seconds before a user can purchase drops again.
                    (0 = no reset)
                </div>
                <div>
                    <InputField
                        className="w-64"
                        type="number"
                        variant="bordered"
                        isRequired={true}
                        label="Account limit cooldown"
                        onWheel={(e) => e.target.blur()}
                        value={accountLimitCoolDown}
                        onChange={(e) =>
                            setAccountLimitCoolDown(parseInt(e.target.value))
                        }
                        min={0}
                    />
                </div>
            </div>
            <Collapse in={!isPremint}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-10 mb-5">
                    <div className="my-auto">
                        <div>
                            {`Buying RAM for ${
                                isNaN(ramToBuyInWax) ? 0 : ramToBuyInWax
                            } WAX will bring your balance to ≈ ${extraRamBytesAfterRamBought} Bytes, 
                            which will allow users to claim approximately ${parseInt(
                                Math.floor(
                                    extraRamBytesAfterRamBought /
                                        (isPfp ? 450 : 151),
                                ),
                            )} Drops.`}
                        </div>
                    </div>
                    <div>
                        <InputField
                            className="w-64"
                            type="number"
                            variant="bordered"
                            isRequired={true}
                            label="RAM to Buy in WAX"
                            onWheel={(e) => e.target.blur()}
                            isInvalid={
                                maxClaimable !== 0 &&
                                parseInt(
                                    Math.floor(
                                        extraRamBytesAfterRamBought /
                                            (isPfp ? 450 : 151),
                                    ),
                                ) <
                                    (maxClaimable / 10.0) *
                                        (checkedTemplateIds !== null &&
                                        checkedTemplateIds.size > 0
                                            ? checkedTemplateIds.size
                                            : 1)
                            }
                            value={ramToBuyInWax}
                            onChange={(e) => {
                                setRamToBuyInWax(parseFloat(e.target.value))
                            }}
                            min={mustBeFinite ? 1 : 0}
                        />
                    </div>
                </div>
            </Collapse>

            <Collapse
                in={parseInt(maxClaimable) === 0 && !mustBeFinite && !isPremint}
            >
                <div className="mb-5">
                    <Alert severity="warning">
                        Make sure to allocate enough RAM for this Drop! You set
                        the claimable amount to 'infinite' So we cannot
                        calculate the amount of RAM you will need.
                    </Alert>
                </div>
            </Collapse>

            <DropAlert
                condition={isDropAmountInvalid({
                    maxClaimable,
                    accountLimit,
                    accountLimitCoolDown,
                    waxRam: ramToBuyInWax,
                    ramBytes: extraRamBytesAfterRamBought,
                    checkedTemplateIds,
                    mustBeFinite,
                    isPremint,
                    isPfp,
                })}
                severity="error"
                elementId="DropAmountEditor"
            >
                {isDropAmountInvalid({
                    maxClaimable,
                    accountLimit,
                    accountLimitCoolDown,
                    waxRam: ramToBuyInWax,
                    ramBytes: extraRamBytesAfterRamBought,
                    checkedTemplateIds,
                    mustBeFinite,
                    isPremint,
                    isPfp,
                })}
            </DropAlert>
        </DropPaper>
    )
}
